import { render, staticRenderFns } from "./PelleRift.vue?vue&type=template&id=9e8641b2&scoped=true&"
import script from "./PelleRift.vue?vue&type=script&lang=js&"
export * from "./PelleRift.vue?vue&type=script&lang=js&"
import style0 from "./PelleRift.vue?vue&type=style&index=0&id=9e8641b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8641b2",
  null
  
)

export default component.exports